import PropTypes from 'prop-types';
import { ReservationPointsOfSale, ReservationStatuses } from '../constants';
import { PassInfoDefaults, PassInfoProps } from './passInfo';

export const ReservationProps = PropTypes.shape({
  id: PropTypes.string,
  account_id: PropTypes.string,
  order_id: PropTypes.string,
  facility_id: PropTypes.string,
  pass_type_id: PropTypes.string,
  reservation_number: PropTypes.string,
  pass_info: PassInfoProps,
  price: PropTypes.number,
  clin: PropTypes.number,
  sku: PropTypes.string,
  quantity: PropTypes.number,
  point_of_sale: PropTypes.oneOf(ReservationPointsOfSale),
  status: PropTypes.oneOf(ReservationStatuses),
  created_at: PropTypes.string,
  updated_at: PropTypes.string
});

export const ReservationDefaults = {
  id: null,
  account_id: null,
  order_id: null,
  facility_id: null,
  pass_type_id: null,
  reservation_number: null,
  pass_info: PassInfoDefaults,
  price: 0,
  clin: 0,
  sku: "",
  quantity: 0,
  point_of_sale: 'web',
  status: 'pending',
  created_at: null,
  updated_at: null
};
